<template>
  <div class="presentation-detail">
    <div class="presentation-detail-header">
      <div
        class="back-to-list"
        @click="backToAttendedPresentationList"
      >
        <span class="icon">
          <i class="fas fa-chevron-left" />
        </span>
        <span class="text">{{ $t('presentation_details') }}</span>
      </div>
    </div>
    <div class="presentation-detail-body">
      <PresentationLookback v-if="isLoaded" />
    </div>
  </div>
</template>

<script>
import util from '@/util'
import PresentationLookback from '@/components/my-quiz-answers/PresentationLookback.vue'
import { mapState } from 'vuex'
import * as AttendedPresentationUtil from '@/utils/attendedPresentation.util'

export default {
  components: {
    PresentationLookback,
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    isLoaded() {
      const presentationId = AttendedPresentationUtil.getValueByPresentationUniqueAccessCode(
        this.$route.params.id,
        'id',
      )

      return (this.presentation && this.presentation.id) || presentationId
    },
  },
  methods: {
    backToAttendedPresentationList() {
      this.$router.push({
        name: 'Profile',
        query: {},
      })

      util.ga4Track('Account > Presentation details > Back', {
        presentationId: this.presentation && this.presentation.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-detail {
  &-header {
    background-color: #fff;

    border-bottom: #EFF1F7;
  }

  .back-to-list {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
    text-align: center;
    position: relative;
    padding: 16px;
    cursor: pointer;

    .text {
      color: #191F2D;
      font-weight: bold;
      text-transform: capitalize;
    }

    .icon {
      color: #0A0A0AB2;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 50%;
      left: 16px;
      transform: translateY(-50%);
    }
  }
}
</style>
